// removed by extract-text-webpack-plugin
module.exports = {"trending":"trendingSash-module_trending_3oQJK"};


//////////////////
// WEBPACK FOOTER
// ./client/components/itemCard/common/trendingSash.module.css
// module id = 1018
// module chunks = 1